import { LoginBody } from "@/types";
import axiosInstance from "./api";

export function loginService(
  body: LoginBody,
): Promise<{ accessToken: string }> {
  return axiosInstance
    .post("/admin/login", body)
    .then((response) => response.data);
}
